import type { CreateMessageInput } from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export interface CreateMessageMutation {
  createMessage: { id: string; value: string };
}

export interface CreateMessageMutationVariables {
  input: CreateMessageInput;
}

export const CREATE_MESSAGE: TypedDocumentNode<
  CreateMessageMutation,
  CreateMessageMutationVariables
> = gql`
  mutation CreateMessage($input: CreateMessageInput!) {
    createMessage(input: $input) {
      id
      value
    }
  }
`;
